/* ============
 * Dashboard
 * ============
 *
 * This is the dashboard page.
 */

import { mapGetters, mapMutations } from 'vuex';
import Forms from '../../utils/forms/forms';
import orderService from './../../services/order';
import store from './../../store';

export default {
  data() {
    return {
      form: new Forms({
        internalNote: {
          type: 'textarea',
          value: '',
        },
      }),
      loading: false,
    }
  },

  computed: {
    ...mapGetters({
      currentOrder: 'currentOrder',
    }),
  },

  mounted() {
    // console.log(this.currentOrder);
  },

  watch: {
    //
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      setModalProps: 'SET_MODAL_PROPS',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
      setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
      setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
      setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
    }),

    store() {
      this.loading = false;
      this.form.loading = true;
      const data = Object.assign({}, this.currentOrder, { invoiceExternal: true, internalNote: this.form.internalNote });
      return orderService.update(store.state.route.params.id, data)
        .then(() => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: 'Success',
            customClass: 'success',
          });
          this.closeModal();
        }).catch((errors) => {
          this.loading = false;
          this.form.loading = false;
          let message = errors.data.message;
          if (errors.data.confirm_date) {
            message = errors.data.confirm_date[0];
          }

          this.$message({
            showClose: true,
            message,
            customClass: 'error',
          });
        });
    },

    /*
     * Closes the modal
     */
    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
    },
  },
  components: {
    VForm: require('./../../components/form/form.vue'),
    VMessage: require('./../../components/form/message/message.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/invoiceExternalPopup/invoiceExternalPopup.js